import React from 'react';
import styled from 'styled-components';

import H1 from '../../collections/H1/H1';

import { media } from '../../utilities/style-utilities';
import { emy, fontUbuntuLight } from '../../utilities/utilities';

const CardWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 964px;
  background-color: white;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 300px;
  z-index: 1;
  margin-top: ${ props => props.overlay === false ? '8rem' :  '16rem' };
  margin-bottom: 2rem;
  border-radius: 0.75rem;
  -webkit-box-shadow: 0px 0px 6px 2px rgba(0,0,0,0.3);
  -moz-box-shadow: 0px 0px 6px 2px rgba(0,0,0,0.3);
  box-shadow: 0px 0px 6px 2px rgba(0,0,0,0.3);

  ${ media.desktop`
    margin: 1rem;
  `}
`;

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
`;

const Header = styled.header`
  margin-top: 1rem;
  min-height: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  flex-direction: column;
  &::before {
    content: '';
    border-top: 2px solid #e6e6e6;
    position: absolute;
    left: 1rem;
    right: 1rem;
    bottom: 0;
  }

  ${ media.desktop`
    margin-top: 0rem;
  `}
  
`;

const Content = styled.div`
  flex: 1 1 auto;
  position: relative;
  margin: 1rem 0;
`;

const ContentInner = styled.div`
  display: flex;
  flex-direction: column;
`;

const Footer = styled.div`
  min-height: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 1.5rem 0;
  &::before {
    content: '';
    border-top: 2px solid #e6e6e6;
    position: absolute;
    left: 1rem;
    right: 1rem;
    top: 0;
  }
`;

const StyledH1 = styled(H1)`
  display: block;
  font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
  
  color: ${props => props.textColor ? props.textColor : '#0d1b58'};
  font-size: 1.5em;
  margin: 1rem 0;
  ${ media.desktop`
    margin: 0.5rem 0;
  `}
  ${ media.tablet`
    margin: 0.2rem 1rem;
  `}
`;

const CardNoBorder = (props) => {
  const StyledHeader = props.header;
  let cardName = props.pageTitle ? props.pageTitle : props.card.titleText;
  return (
    <CardWrapper overlay={props.card.overlayOverMarketingBanner}>
      <InnerWrapper>

        {props.header ? 
        <Header>
          <StyledH1 fontFamily={props.card.fontFamily} textColor={props.card.titleTextColor}>{props.name}</StyledH1>
          <StyledHeader textColor={props.card.titleTextColor} center fontSize={emy(42.08)}>{props.card.titleText}</StyledHeader>
        </Header>
        :
        <Header>
          <H1 fontFamily={props.card.fontFamily} textColor={props.card.titleTextColor} center fontSize={emy(42.08)}>{cardName}</H1>
        </Header>
        }

        <Content>
          <ContentInner>
            {props.children}
          </ContentInner>
        </Content>

        { props.footer ? 
          <Footer>
            <button onClick={props.backHandler}>Back</button>
            <button onClick={props.nextHandler}>Next</button>
          </Footer>
          : 
          null
        }

        
      </InnerWrapper>
    </CardWrapper>
  )
};

export default CardNoBorder;


// WEBPACK FOOTER //
// ./src/components/Card/CardNoBorder.js